import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import { listingStates } from "../../util/flStates";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

function SubscriptionSuccess() {
  return <div>
    <Navbar />
      <Box
        sx={{
          textAlign: "center",
          padding: "2rem",
          border: "1px solid #4CAF50",
          borderRadius: "8px",
          backgroundColor: "#E8F5E9",
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#4CAF50" }} />
        <Typography variant="h4" sx={{ color: "#4CAF50", marginTop: "1rem" }}>
          Your subcription is successfull!
        </Typography>
        {/* <div style={{marginTop: "10px"}}>
          Thank you .
        </div> */}
        
      </Box>
      <Footer/>
  </div>;
}

export default SubscriptionSuccess;
